import { useSkills } from "routes/@lib/skills"
import { BoundPopup } from "lib/@components/combos/boundPopup"
import { SummaryDataChanged } from "event-definitions"
import { RegimeDraftLockTooltip } from "routes/regime/regime-draft-locking/regime-draft-lock-tooltip"

export function EditSkills({ onClick, children }) {
    const [skillSets] = useSkills()
    return (
        <>
            {!!skillSets && (
                <RegimeDraftLockTooltip disableTitle>
                    <BoundPopup
                        onChanged={SummaryDataChanged.raiseOnce}
                        field="skillSet"
                        label="Skill"
                        options={Object.fromEntries(
                            Object.values(skillSets).map(({ CoreSkillingID, SkillingCode, Skilling }) => [
                                CoreSkillingID,
                                `${SkillingCode}: ${Skilling}`,
                            ])
                        )}
                        onClick={onClick}
                        data-cy="edit-skills"
                    >
                        {children}
                    </BoundPopup>
                </RegimeDraftLockTooltip>
            )}
        </>
    )
}
